(function () {
  'use strict';
  // A quiet scroll gate: no body locks, form state changes, or popup triggers.
  function createScrollGate(options) {
    const delay = options.delay == null ? 1000 : options.delay;
    const setTimer = options.setTimer || setTimeout;
    const clearTimer = options.clearTimer || clearTimeout;
    let timer = null, active = false;
    const change = value => {
      if (active === value) return;
      active = value;
      options.onChange(value);
    };
    const reset = () => {
      if (timer !== null) clearTimer(timer);
      timer = null;
      change(false);
    };
    return {
      onScroll() {
        change(true);
        if (timer !== null) clearTimer(timer);
        timer = setTimer(() => { timer = null; change(false); }, delay);
      },
      reset,
      isActive: () => active,
    };
  }
  const hideCss = ':host([data-fxl-scroll-teaser-hidden]) [data-form-root][data-current-step="tease"]{opacity:0!important;visibility:hidden!important;pointer-events:none!important;}';
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {createScrollGate, hideCss};
    return;
  }
  if (window.FXLPromoScrollReady) return;
  window.FXLPromoScrollReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hosts = new Set(), bound = new WeakSet(), animations = new WeakMap();
  function apply(host, scrolling) {
    // Do not withdraw an entrance while a keyboard user is operating it.
    const hide = scrolling && !host.matches(':focus-within');
    const wasHidden = host.hasAttribute('data-fxl-scroll-teaser-hidden');
    if (wasHidden === hide) return;
    animations.get(host)?.cancel();
    animations.delete(host);
    host.toggleAttribute('data-fxl-scroll-teaser-hidden', hide);
    if (!hide && wasHidden && !reduced.matches && !document.hidden) {
      const entrance = host.shadowRoot?.querySelector('[data-form-root][data-current-step="tease"]');
      if (!entrance) return;
      const style = getComputedStyle(entrance), rect = entrance.getBoundingClientRect();
      // Restore only an entrance that the Forms app itself still considers visible.
      if (style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && rect.width > 0 && rect.height > 0 && entrance.animate) {
        animations.set(host, entrance.animate([{opacity:0},{opacity:1}],{duration:140,easing:'ease-out'}));
      }
    }
  }
  const gate = createScrollGate({onChange:scrolling => hosts.forEach(host => apply(host,scrolling))});
  function bind(host) {
    if (bound.has(host) || !host.shadowRoot) return;
    bound.add(host); hosts.add(host);
    function ensureStyle() {
      if (!host.shadowRoot.querySelector('[data-fxl-scroll-teaser-style]')) {
        const style = document.createElement('style');
        style.dataset.fxlScrollTeaserStyle = '';
        style.textContent = hideCss;
        host.shadowRoot.append(style);
      }
      apply(host,gate.isActive());
    }
    new MutationObserver(ensureStyle).observe(host.shadowRoot,{childList:true,subtree:true});
    ensureStyle();
  }
  const scan = () => document.querySelectorAll('shopify-forms-embed').forEach(bind);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('shopify-forms-embed') || node.querySelector('shopify-forms-embed') || node.closest('shopify-forms-embed'))))) scan();
    hosts.forEach(host => { if (!host.isConnected) { animations.get(host)?.cancel(); hosts.delete(host); } });
  }).observe(document.body,{childList:true,subtree:true});
  // Capture also covers native nested result lists. Never cancel a scroll event.
  document.addEventListener('scroll',gate.onScroll,{capture:true,passive:true});
  document.addEventListener('focusin',()=>hosts.forEach(host=>apply(host,gate.isActive())));
  document.addEventListener('focusout',()=>hosts.forEach(host=>apply(host,gate.isActive())));
  document.addEventListener('visibilitychange',()=>{if(document.hidden)gate.reset();});
  window.addEventListener('pagehide',gate.reset);
  window.addEventListener('pageshow',()=>{gate.reset();scan();});
  customElements.whenDefined('shopify-forms-embed').then(scan);
  scan();
})();
